export const FETCHING_TASKS_TO_DO = 'FETCHING_TASKS_TO_DO'
export const FETCHED_TASKS_TO_DO = 'FETCHED_TASKS_TO_DO'
export const FETCHING_WIDGET_ASSOCIATED_TASKS = 'FETCHING_WIDGET_ASSOCIATED_TASKS'
export const FETCHED_WIDGET_ASSOCIATED_TASKS = 'FETCHED_WIDGET_ASSOCIATED_TASKS'


const tasksToDoInit = {
  isFetching: true,
  maxPage: 0,
  data: [],
  widgetAssociated: {
    isFetching: true,
    data: [],
  },
}

export function tasksToDo(tasksToDo=tasksToDoInit, action) {
  switch(action.type) {
    case FETCHING_TASKS_TO_DO:
      return {
        ...tasksToDo,
        isFetching: true,
        maxPage: 0,
        data: [],
      }
    case FETCHED_TASKS_TO_DO:
      return {
        ...tasksToDo,
        isFetching: false,
        maxPage: action.maxPage,
        data: action.tasksToDo,
      }
    case FETCHING_WIDGET_ASSOCIATED_TASKS:
      return {
        ...tasksToDo,
        widgetAssociated: {
          ...tasksToDo.widgetAssociated,
          isFetching: true,
          data: [],
        }
      }
    default:
      return tasksToDo
  }
}
